function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.3332 26.9991C14.3332 20.0166 20.0173 14.3324 26.9998 14.3324C33.9823 14.3324 39.6665 20.0166 39.6665 26.9991C39.6665 33.9816 33.9823 39.6657 26.9998 39.6657C20.0173 39.6657 14.3332 33.9816 14.3332 26.9991ZM11.1665 26.9991C11.1665 35.7438 18.2551 42.8324 26.9998 42.8324C35.7446 42.8324 42.8332 35.7438 42.8332 26.9991C42.8332 18.2543 35.7446 11.1657 26.9998 11.1657C18.2551 11.1657 11.1665 18.2543 11.1665 26.9991ZM25.4165 19.0824V25.4157H19.0832V28.5824H25.4165V34.9157H28.5832V28.5824H34.9165V25.4157H28.5832V19.0824H25.4165Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.129883,
  y: 27,
  width: 38,
  height: 38,
  transform: "rotate(-45 0.129883 27)"
})));

var SvgAddbadge = function SvgAddbadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddbadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/addbadge.18351a3f.svg";
export { ForwardRef as ReactComponent };